module.exports = __webpack_public_path__ + "static/media/headerSearchIcon.90770942.svg";